/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-10 11:51:48
 * @FilePath: /mrc-ess-fronted/src/util/progress.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-26 17:53:21
 */
//加载
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import router from "../router";
import _this from "../main.js";
// 配置NProgress进度条选项  —— 动画效果
NProgress.configure({
  easing: "ease",
  speed: 500,
  showSpinner: false,
  trickle: false,
  minimum: 0.2,
  template:
    '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>',
});
$(document)
  .ajaxStart(function (e) {
    // 全局控制加载，这个由global(默认true)参数控制，若不必显示加载，设置global:false,高级参照设置false,eg:findPrompt(data,false)
    if (_this) {
      _this.$store.dispatch("setLoading", true);
    }
    // 此项被废弃，使用vuetify的progress，
    NProgress.start();
  })
  .ajaxStop(function () {
    if (_this) {
      _this.$Sleep(500).then(() => {
        _this.$store.dispatch("setLoading", false);
      });
    }
    // 此项被废弃，使用vuetify的progress，
    NProgress.done();
  });
export default NProgress;
